export default {
  title: 'Administrador de KeyPal',
  desc: 'Tu herramienta de actualización de firmware de KeyPal',
  download: 'Descargar KeyPal Bridge',
  onLine: 'Actualización en línea',
  goDesktop: 'Por favor, utiliza una computadora para operar',
  macTitle: 'Mac(Apple Silicon)',
  question_1: '¿Cómo actualizar KeyPal a través de la aplicación de escritorio?',
  question_2: '¿Cómo actualizar a través de la web?',
}
